import { Box, Grid, Typography } from "@mui/material";
import successSignup from "@/assets/image/success_signup.png";
import { AsarButton } from "@/components";
import { useNavigate } from "react-router-dom";

function SuccessSignup() {
  const navigate = useNavigate();
  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"32px"}
        padding={"20px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <img style={{ width: "calc(min(100%, 400px))" }} src={successSignup} />
        <Grid
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={"12px"}
        >
          <Typography sx={{ color: "var(--emr-text-bold)" }}>
            {"درخواست شما ثبت شد"}
          </Typography>
          <Typography sx={{ color: "var(--emr-text-light)" }}>
            {
              "پس از تایید ادمین، شما می‌توانید از سامانه اردو جهادی اثر استفاده کنید."
            }
          </Typography>
        </Grid>
        <AsarButton onClick={() => navigate("/login")}>
          {"بازگشت به ورود"}
        </AsarButton>
      </Grid>
    </>
  );
}

export default SuccessSignup;
